import React from 'react'
import {Popup} from 'semantic-ui-react'
import Utils from './../../../modules/utils'
import {needsTickets, ticketLabel} from '../needs-tickets'
import {TicketChip} from '../ticket-chip'

const ticketsPopup = (po) => {
  return (
    !needsTickets(po.ticketed)
    ?
    null
    :
    <Popup
      size='mini'
      header={"This order needs tickets"}
      content={
        <table style={{whiteSpace: 'nowrap'}}>
          <tr><td style={{opacity: 0.5}}>Type &nbsp;</td><td style={{fontWeight: 'bold'}}>{ticketLabel(po.ticketed)}</td></tr>
          {
            po.ticketsOrdered
            ?
            <tr><td style={{opacity: 0.5}}>Ordered on</td><td style={{fontWeight: 'bold'}}>{Utils.formatSimpleDate(po.ticketsOrderedDate)}</td></tr>
            :
            <div><u>NOT ordered yet!</u></div>
          }

          {po.ticketsConfirmationNumber != null && po.ticketsConfirmationNumber.replace(' ','') != '' ?
            <tr><td style={{opacity: 0.5}}>Confirmation # &nbsp;</td><td style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{po.ticketsConfirmationNumber}</td></tr>
          : null}

          {po.ticketsTrackingNumber != null && po.ticketsTrackingNumber.replace(' ','') != '' ?
            <tr><td style={{opacity: 0.5}}>Tracking # &nbsp;</td><td style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{po.ticketsTrackingNumber}</td></tr>
          : null}
        </table>
      }
      position='bottom left'
      trigger={
      <TicketChip ticketed={po.ticketed} ticketsOrdered={po.ticketsOrdered}/>
    } />
  )
}

export {ticketsPopup}
